module.exports = __webpack_public_path__ + "static/renta-5702e62c22bc3a1e38446b748a52cf2b.pdf";